import React, { useEffect, useState } from "react";
import { useDebounce } from "use-debounce";
import { FiSearch, FiX } from "react-icons/fi";

const SearchInput = ({ value, onChange, placeholder = "Rechercher...", className = "" }) => {
  const [searchValue, setSearchValue] = useState(value || "");
  const [debouncedValue] = useDebounce(searchValue, 500);

  useEffect(() => {
    if (onChange) {
      onChange(debouncedValue);
    }
  }, [debouncedValue]);

  useEffect(() => {
    setSearchValue(value || "");
  }, [value]);

  return (
    <div className={`relative ${className}`}>
      <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
        <FiSearch className="h-5 w-5 text-gray-400" />
      </div>
      <input
        type="text"
        value={searchValue}
        onChange={(e) => setSearchValue(e.target.value)}
        placeholder={placeholder}
        className="block w-full pl-10 pr-10 py-2 border border-gray-300 rounded-lg leading-5 bg-white placeholder-gray-500 focus:outline-none focus:placeholder-gray-400 focus:ring-1 focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
      />
      {searchValue && (
        <button type="button" onClick={() => setSearchValue("")} className="absolute inset-y-0 right-0 pr-3 flex items-center hover:text-gray-700">
          <FiX className="h-5 w-5 text-gray-400" />
        </button>
      )}
    </div>
  );
};

export default SearchInput;
